export const jobs = [
  {
    id: 1,
    title: "Node.js developer",
    description: "Looking for a performance-driven full-stack Node.js developer who can help us bring Tedekstra to the next level of functionality, scalability, and user experience.",
    date: "Jan 12, 2026",
    location: "Bangalore, IN",
    image: "/images/node.png",
    isFeatured: true
  },
  {
    id: 2,
    title: "Business Analyst with minimum 5 years experience",
    date: "Jan 12, 2026",
    location: "Bangalore, IN",
    isFeatured: false
  },
  {
    id: 3,
    title: "Full Stack Developer with min 8 years experience",
    date: "Jan 12, 2026",
    location: "Bangalore, IN",
    isFeatured: false
  },
  {
    id: 4,
    title: "Sales Consultant with min 2 years experience",
    date: "Jan 12, 2026",
    location: "Bangalore, IN",
    isFeatured: false
  }
];
